<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">{{ title }}</h5>
    <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close" (click)="onCancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>{{ body }}</p>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-primary"
      data-dismiss="modal"
      (click)="onConfirm()"
    >
      {{ buttonConfirmText}}
    </button>
    <button
      type="button"
      class="btn btn-primary"
      data-dismiss="modal"
      (click)="onNo()"
    >
    {{ buttonCancelText}}
    </button>
  </div>
</div>
